var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":"12","md":"12"}},[(_vm.list)?_c('v-alert',{attrs:{"dense":"","outlined":"","type":"error"}},_vm._l((_vm.list),function(error,key){return _c('span',{key:key},[_vm._v("\n            "+_vm._s(error)),_c('br')])}),0):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }